import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Compbaser} from "../compbaser";
import {IAppSettingsWrap, IAppStatic, IUser} from "../../interfaces";
import {DEFAULT_RESELLER_ID} from "../../common";
import {faAndroid, faApple, faGooglePlay, faLinux, faMicrosoft} from "@fortawesome/free-brands-svg-icons";
import {faBolt, faGlobe, faEdit} from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthUserService, StoreSelectorsService} from "../../services";
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-studio-download',
    styleUrls: ['./studio-download-component.scss'],
    templateUrl: './studio-download-component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudioDownloadComponent extends Compbaser {
    coreAppData: IAppSettingsWrap;
    appStatic: IAppStatic;
    faMicrosoft = faMicrosoft;
    faGlobe = faGlobe;
    faApple = faApple;
    faEdit = faEdit;

    @Input() set proStudioOnly(value) {
        this.m_proStudioOnly = true;
        // this.textualContent = this.textualContent.splice(1);
    }

    @Input() showMenu;

    // textualContent = [
    //     {
    //         class: 'web',
    //         icon: faGlobe,
    //         type: 'studio_web',
    //         h1: 'Get SignStudio',
    //         h2: 'Chrome | Edge | Safari | All operating systems'
    //     },
    //     {
    //         class: 'microsoft',
    //         icon: faMicrosoft,
    //         type: 'studio_exe',
    //         h1: 'Get LegacyStudio Desktop exe (legacy)',
    //         h2: 'Windows edition | 36 megabytes | 64 bit',
    //         legacy: true
    //     },
    //     {
    //         class: 'apple',
    //         icon: faApple,
    //         type: 'studio_dmg',
    //         h1: 'Get LegacyStudio Desktop dmg  (legacy)',
    //         h2: 'Apple edition OSX | 18 megabytes | 64 bit',
    //         legacy: true
    //     },
    //     {
    //         class: 'microsoft',
    //         icon: faMicrosoft,
    //         type: 'studio_air',
    //         h1: 'Get LegacyStudio Adobe Runtime air',
    //         h2: 'Windows edition | 36 megabytes | 64 bit',
    //         legacy: true,
    //         extra: {
    //             class: 'microsoft',
    //             icon: faMicrosoft,
    //             type: 'player_air_exe',
    //             h2: '| requires separate AIR install',
    //         }
    //     },
    //     {
    //         class: 'apple',
    //         icon: faApple,
    //         type: 'studio_air',
    //         h1: 'Get LegacyStudio air ',
    //         h2: 'Apple edition OSX | 23 megabytes | 32 bit',
    //         legacy: true,
    //         extra: {
    //             class: 'apple',
    //             icon: faApple,
    //             type: 'player_air_dmg',
    //             h2: '| requires separate AIR install',
    //         }
    //     }
    // ];

    user: IUser;
    name = '';
    devMode = '';
    largeLogo = '1';
    businessName = '';
    resellerId = DEFAULT_RESELLER_ID;
    m_proStudioOnly = false;
    showLegacyDownloads = false;

    constructor(private authUserService: AuthUserService,
                private translocoService: TranslocoService,
                private storeSelector: StoreSelectorsService,
                public router: Router,
                private route: ActivatedRoute) {
        super();
        const move = (arr, from, to) => {
            arr.splice(to, 0, arr.splice(from, 1)[0]);
        };
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        // this.cod(
        //     this.storeSelector.getOS().subscribe((i_os) => {
        //         if (i_os.family !== 'Windows') {
        //             move(this.textualContent, 0, 2);
        //         }
        //     })
        // );
    }

    download(value) {
        switch (value) {
            case 'studio_web': {
                if (this?.coreAppData?.[0]?.enterprise)
                    return window.open(this.coreAppData[1].homePage, '_blank');
                break;
            }
            default: {
            }
        }
        window.open(this.appStatic[value], '_blank');
    }

    toggleLegacyDownloads() {
        this.showLegacyDownloads = !this.showLegacyDownloads;
    }

    protected readonly faAndroid = faAndroid;
    protected readonly faGooglePlay = faGooglePlay;
    protected readonly faBolt = faBolt;
    protected readonly faLinux = faLinux;
}

